<template>
    <div class="frame-content">
        <div class="frame-content-wrap">
            <div class="filter">
                <div class="inline mr-8">
                    <el-select v-model="filters.userId" clearable placeholder="操作员" size="small" @clear="clearSelect">
                        <el-option v-for="(item) in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="inline date mr-8">
                    <el-date-picker
                        v-model="filters.startTime"
                        type="datetime"
                        placeholder="开始时间"
                        size="small"
                        value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </div>
                <div class="inline date mr-8">
                    <el-date-picker
                        v-model="filters.endTime"
                        type="datetime"
                        placeholder="结束时间"
                        size="small"
                        value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </div>
                <div class="inline mr-8">
                    <el-button type="primary" size="small" icon="el-icon-search" @click="loadTable">查询</el-button>
                </div>
            </div>
            <div class="datatable-wrap mt-10">
                <div class="datatable person-tab">
                    <el-table
                        ref="currentTable"
                        :data="tableData"
                        v-loading="tableLoading"
                        element-loading-background="rgba(255, 255, 255, 0.3)"
                        border
                        style="width: 100%">
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            label="操作人">
                        </el-table-column>
                        <el-table-column
                            prop="supplierName"
                            label="分包单位"
                            min-width="200">
                        </el-table-column>
                        <el-table-column
                            prop="workerName"
                            label="劳务人员">
                        </el-table-column>
                        <el-table-column
                            prop="operationName"
                            label="操作类型"
                            min-width="200">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="操作时间"
                            min-width="200">
                        </el-table-column>
                        
                    </el-table>
                </div>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :background="true"
                        :current-page="pageNum"
                        :page-sizes="[50, 100, 200, 300, 400, 500]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
 
export default {
    name: 'SystemUserLog',
    components: {},
    data() {
        return {
            BASE_URL: http.BASE_URL,
            userList:[], // 操作员列表
            filters: {
                userId: '',
                startTime: '',
                endTime: ''
            },

            tableData: [],

            totalNum: 0,
            pageNum: 1,
            pageSize: 50,

            tableLoading: false,
        };
    },
    created () {
        this.loadTable();
        this.loadUserList();
    },
    methods: {
        ...common,
        loadUserList() {
            let params = {
                pageNum: 1,
                pageSize: 1000
            }
            http.get("v1/user/listPage", {
                params: params
            }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.userList = req.data.data.records;
                }
                else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.httpCatch(err);
            });
        },
        // 加载表格数据
        loadTable() {
            let params = {...this.filters};

            params.pageNum = this.pageNum;
            params.pageSize = this.pageSize;

            this.tableLoading = true;
            http.post('v1/user/operation/log', params).then(req => {
                this.tableLoading = false;
                if (req.data.code == http.SUCCESS) {
                    this.tableData = req.data.data.records;
                    this.totalNum = req.data.data.total;
                    this.curPageNum = this.pageNum;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        clearSelect() {
            this.filters.userId = '';
            this.filters.startTime = '';
            this.filters.endTime = '';
            this.loadTable();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.loadTable();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.loadTable();
        },
    }
}
</script>

<style scoped>
</style>
